"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _fetchHelper = require("../../util/fetchHelper");
var _environmentHelper = _interopRequireDefault(require("../../util/environmentHelper"));
const loginCustomer = async (email, password, loginBy) => {
  const API_URL = (0, _environmentHelper.default)();
  const url = "".concat(API_URL, "/auths");
  try {
    const resp = await (0, _fetchHelper.fetchWithHeaders)(url, {
      method: 'POST',
      body: JSON.stringify({
        email,
        password,
        ...loginBy
      })
    });
    const json = await resp.json();
    return {
      status: resp.status,
      ...json
    };
  } catch (error) {
    return error;
  }
};
var _default = exports.default = loginCustomer;